
export default {
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    computed: {
        attachments() {
            const attachments = [];
            if (this.product.product_information?.length > 1) {
                attachments.push({
                    url: this.product.product_information,
                    label: this.$t('catalog.product.attachment.info'),
                });
            }
            if (this.product.safety_data?.length > 1) {
                attachments.push({
                    url: this.product.safety_data,
                    label: this.$t('catalog.product.attachment.safety'),
                });
            }
            if (this.product.product_information_other?.length > 1) {
                attachments.push({
                    url: this.product.product_information_other,
                    label: this.$t('catalog.product.attachment.other'),
                });
            }

            return attachments;
        },
    },
};
